import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { setUserProfilesAction } from '../redux/actions/userProfileActions'

export const useUserProfile = () => {
  const { userProfile } = useSelector(
    (state: RootState) => state.userProfile.userProfileState
  )
  const dispatch = useDispatch()

  const setUserProfile = (userProfile: any) => {
    dispatch(setUserProfilesAction(userProfile))
  }

  return { userProfile, setUserProfile }
}
